import { z } from 'zod'
import { paginationQuerySchema } from './api-response.ts'
import { timestampSchema, uuidSchema } from './common.ts'
import { productionEquipmentSchema } from './production-stages.ts'

export const equipmentWorkloadQuerySchema = paginationQuerySchema.extend({
  limit: z.coerce.number().int().positive().max(50).default(50),
  search: z.string().trim().max(200).optional(),
})
export type EquipmentWorkloadQuery = z.infer<typeof equipmentWorkloadQuerySchema>

export const equipmentRunningTaskSchema = z.object({
  stageId: uuidSchema,
  orderId: uuidSchema,
  orderNumber: z.string(),
  itemName: z.string(),
  operationName: z.string(),
  workerId: z.string(),
  workerName: z.string(),
  startedAt: timestampSchema,
})

export const equipmentWorkloadSchema = productionEquipmentSchema.extend({
  runningTask: equipmentRunningTaskSchema.nullable(),
  queuedCount: z.number().int().nonnegative(),
})
export type EquipmentWorkload = z.infer<typeof equipmentWorkloadSchema>

export const equipmentWorkloadPageSchema = z.object({
  equipment: z.array(equipmentWorkloadSchema).max(50),
  summary: z.object({
    total: z.number().int().nonnegative(),
    running: z.number().int().nonnegative(),
    repair: z.number().int().nonnegative(),
    queued: z.number().int().nonnegative(),
  }),
})
export type EquipmentWorkloadPage = z.infer<typeof equipmentWorkloadPageSchema>
